import { TextUtil } from '@alife/simple-ui';
import { CardTypeCode, TemplateTypeCode } from '../index';
import { TimeThreshold } from './index';
export function formatMessage(messageList, locale) {
    var newList = [];
    var lastTime = 0;
    var lastUserType = 0;
    messageList.forEach(function (message) {
        var _a;
        var overTime = message.sendTime - lastTime > TimeThreshold;
        if (overTime) {
            newList.push(getSystemTime(message, locale));
        }
        (_a = updateProps(message, lastUserType, overTime), lastUserType = _a.lastUserType, lastTime = _a.lastTime);
        newList.push(message);
        var systemNote = getSystemNote(message);
        if (systemNote) {
            newList.push(systemNote);
        }
    });
    return newList;
}
function updateProps(message, lastUserType, overTime) {
    message.cardType = +message.cardType;
    var readType = message.status > 0 ? message.status : message.readStatus;
    message.readType = readType;
    var thisUserType = message.user.userType;
    message.displayAvatar = lastUserType !== thisUserType || overTime;
    return { lastUserType: thisUserType || lastUserType, lastTime: message.sendTime };
}
var defaultSystemMsg = {
    messageId: "unset",
    sendTime: 'unset',
    cardType: CardTypeCode.CardSystem,
    templateType: TemplateTypeCode.CardSystem,
    templateData: {
        "txt": 'unset',
    },
    user: { userType: 0 },
    displayAvatar: false,
    status: 0,
    readStatus: 0,
    ext: {}
};
function getSystemTime(message, locale) {
    return Object.assign({}, defaultSystemMsg, {
        messageId: "time-" + message.sendTime,
        sendTime: message.sendTime,
        templateData: {
            "txt": TextUtil.getFriendlyDate(message.sendTime, {
                displayTime: true,
                locale: locale,
            }),
        },
    });
}
function getSystemNote(message) {
    if (message.status === 13) {
        message.hideState = true;
        return Object.assign({}, defaultSystemMsg, {
            messageId: "failed-" + message.sendTime,
            sendTime: message.sendTime,
            templateData: {
                targetId: message.messageId
            },
            cardType: CardTypeCode.CardResend,
            templateType: TemplateTypeCode.CardResend,
        });
    }
}

//# sourceMappingURL=formatMessage.js.map
